import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4b62017f")

_pushScopeId("data-v-4b62017f")
const _hoisted_1 = { class: "container is-fullhd background" }
const _hoisted_2 = { class: "container is-max-widescreen content" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "title is-3 is-spaced" }, "ATB Suche für KN Stückgutaufträge (Import)", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("aside", { class: "subtitle is-5" }, " Bitte geben Sie nachfolgend unsere Tracking No. oder Exportreferenz zum Auftrag ein. Sie bekommen anschließend alle Details zur Sendung angezeigt. Sämtliche Informationen sind unverbindlich. Sie dienen lediglich der Information und ersetzen nicht den Transport- / Auslagerungsauftrag. Dargestellte oder fehlende Informationen bilden keine rechtliche Grundlage bei der Ermittlung von Lagergeld. ", -1)
const _hoisted_5 = {
  key: 0,
  class: "message is-warning"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "message-header" }, [
  /*#__PURE__*/_createVNode("p", null, "Achtung")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "message-body" }, " Leider konnten wir Ihren Auftrag nicht finden. Bitte überprüfen Sie Ihre Eingaben und starten Sie die Suche erneut. Sollte wiederholt kein Ergebnis angezeigt werden, kontaktieren Sie bitte Ihren Ansprechpartner bei Kühne und Nagel. ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Search = _resolveComponent("Search")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      (_ctx.$route.query.error)
        ? (_openBlock(), _createBlock("article", _hoisted_5, [
            _hoisted_6,
            _hoisted_7
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_Search, {
        label: "Tracking Number",
        title: "10 Zeichen Tracking Number",
        pattern: "^\\d{10}$",
        onSearch: _ctx.searchByTN
      }, null, 8, ["onSearch"]),
      _createVNode(_component_Search, {
        label: "Export Referenz",
        pattern: "^\\d{4}-?\\d{4}-?\\d{3}\\.?\\d{3}$",
        title: "Export Referenz",
        onSearch: _ctx.searchByExportReference
      }, null, 8, ["onSearch"])
    ])
  ]))
})